import { withStyles } from '@material-ui/core/styles';

import AlphabetNavigation from './AlphabetNavigation';
import styles from './AlphabetNavigation.styles';

export default withStyles(styles)(AlphabetNavigation);
